import { registerComponent } from '@gig/magic-common';
import UserRestrictionsModalComponent from './user-restrictions-modal.vue.js';

var UserRestrictionsModal = registerComponent(UserRestrictionsModalComponent);

export { UserRestrictionsModal };
